package com.neurobs.ccabserver.translation.components.phraseselection

import com.neurobs.react.semanticui.{UiCheckboxFactory, UiDropdownFactory}
import com.neurobs.react.{ReactUtil}
import com.neurobs.ccabserver.translation.states.{PhraseGroupSelectionStateGenerator, PhraseSelectionStateGenerator}
import com.neurobs.ccabserver.translation.util.{PhraseTranslationManager}
import com.neurobs.react.ReactElementFactory
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

import scala.scalajs.js

@react
object PhraseSelection {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)

  val component = FunctionalComponent[Props] { props =>

    val phraseGroupSelectionState = PhraseGroupSelectionStateGenerator.accessState
    val phraseSelectionState = PhraseSelectionStateGenerator.accessState

    def awaitingServerPhrases = phraseSelectionState.awaitingServerPhrases

    phraseGroupSelectionState.selectedPhraseGroup match {
      case None => null
      case Some(phraseGroupManager) =>
        props.enclosingElement(
          if (awaitingServerPhrases) Seq(UiDropdownFactory.LoadingDropdown("Loading test phrases"))
          else {
            Seq[ReactElement](
              PhraseStatusCheckbox(),
              phraseGroupManager.phraseManagers match {
                case None => UiDropdownFactory.DisabledDropdown("Error loading server phrases", classString = "error")
                case Some(phraseManagerMap) => PhraseDropdown(phraseManagerMap.map(_._2).toList.sortBy(_.phraseIndex))
              }
            )
          }
        )
    }
  }
}

@react
object PhraseStatusCheckbox {
  case class Props()

  val component = FunctionalComponent[Props] { _ =>

    val phraseSelectionState = PhraseSelectionStateGenerator.accessState

    def filterOnTranslationStatus = phraseSelectionState.filterOnTranslationStatus
    def toggleFilterStatus = () => phraseSelectionState.toggleFilterStatus()

    def checkboxStyle = Seq[(String, js.Any)](("color", "white"), ("marginBottom", "10px"))

    UiCheckboxFactory.SingleOptionCheckbox(
      "Only show untranslated phrases",
      toggleFilterStatus,
      filterOnTranslationStatus
    )(checkboxStyle)
  }
}

@react
object PhraseDropdown {

  case class Props(phrases: List[PhraseTranslationManager])

  val component = FunctionalComponent[Props] { props =>

    val phraseSelectionState = PhraseSelectionStateGenerator.accessState
    def filterOnTranslationStatus = phraseSelectionState.filterOnTranslationStatus
    def phraseSelections = {
      if (filterOnTranslationStatus) props.phrases.filterNot(_.isTranslated)
      else props.phrases

    }

    def handleSelect(phrase: PhraseTranslationManager) = phraseSelectionState.setSelectedPhrase(phrase)
    def selectedPhrase = phraseSelectionState.selectedPhrase

    def dropdownItem(phrase: PhraseTranslationManager) = {

      def selector = () => handleSelect(phrase)
      def isTranslated = phrase.isTranslated
      def spanStyleAttributes: Seq[(String, js.Any)] = Seq(("color", if (isTranslated) "green" else "red"))

      List(
        UiDropdownFactory.DropdownItem(
          handleClick = selector,
          keyString = phrase.phraseId.toString
        )(
          UiDropdownFactory.DropdownText(phrase.phrase.text),
          ReactElementFactory.Br,
          UiDropdownFactory.DropdownSubtext("Translation status: "),
          UiDropdownFactory.DropdownSubtext(
            text = if (isTranslated) "complete" else "incomplete",
            styleAttributes = spanStyleAttributes
          )
        )
      )
    }

    UiDropdownFactory.SelectionDropdown[PhraseTranslationManager](
      placeholder = if (filterOnTranslationStatus && phraseSelections.length == 0) "All phrases have been translated" else "Select phrase",
      selections = phraseSelections,
      itemGenerator = dropdownItem(_),
      selected = selectedPhrase,
      displayGenerator = _.phrase.text
    )
  }
}
